export type Format = 'png' | 'jpeg' | 'webp'
export interface Coordinates {
  x: number,
  y: number,
}

export interface Options {
  resize?: {
    height?: number,
    width?: number,
  },
  crop?: {
    smart?: boolean,
    from?: Coordinates,
    to?: Coordinates,
  }
  filter?: {
    fill?: number,
    format?: Format,
    quality?: number,
    grayscale?: number,
    blur?: number,
    rotation?: number,
    brightness?: number,
  }
}

export function imageService(path: string, options: Options): string {
  return [
    path + '/m',
    options.resize && `${options.resize.width ?? 0}x${options.resize.height ?? 0}`,
    options.filter && `filters${[
      options.filter.format && `:format(${options.filter.format})`,
    ].filter(o => o).join('')}`,
    // TODO: add more
  ].filter(o => o).join('/')
}
